module.exports = __webpack_public_path__ + "media/images/iconDown__accent-5f9ca107cf4304c61dde511664f22372.png";